<template>
  <div class="sffooter shadow-box">
    <div class="left" @click="gotoHome">
      <div class="top"><img v-show="active !== 'home'" src="../../../assets/img/common/home.png" /><img v-show="active === 'home'" src="../../../assets/img/common/home2.png" /></div>
      <div class="bottom" :class="{'active': active === 'home'}">首页</div>
    </div>
    <div class="right" @click="gotoMy">
      <div class="top"><img v-show="active !== 'my'" src="../../../assets/img/common/my.png" /><img v-show="active === 'my'" src="../../../assets/img/common/my2.png" /></div>
      <div class="bottom" :class="{'active': active === 'my'}">我的</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'sffooter',
    props:{
      active: {
        type: String,
        default: () => {
          return ''
        }
      }
    },
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
    },
    created() {
    },
    methods: {
      gotoHome() {
        this.$router.push('/sf/home')
      },
      gotoMy() {
        this.$router.push('/sf/my')
      }
    }
  }
</script>
<style lang="less" scoped>
  .shadow-box {
    background-color: #fff;
    box-shadow: 0 -8px 20px rgba(0, 0, 0, 0.1); /* 水平偏移为0，垂直偏移为负，模糊半径为8px，颜色为半透明黑色 */
  }
  .sffooter{
    font-weight: 400;
    font-size: 31px;
    color: #1D1403;
    line-height: 21px;
    width:100%;
    position:fixed;
    bottom:0px;
    height:100px;
    padding-bottom:20px;
    display:flex;
    .active{
      color:#FF5400;
    }
    .left{
      flex:1;
      height:100px;
      text-align:center;
      .top{
        padding-top:20px;
        margin-bottom:10px;
      }
      img{
        width:45px;
        height:auto;
      }
    }
    .right{
      height:100px;
      flex:1;text-align:center;
      .top{
        padding-top:20px;
        margin-bottom:10px;
      }
      img{
        width:45px;
        height:auto;
      }
    }
  }

</style>
